import {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";

export function useRedirectAuthenticatedEffect(target = '/') {
    const navigate = useNavigate();
    const {context} = useContext(GlobalContext);

    useEffect(() => {
        if (context.currentIdentity !== null) {
            navigate(target);
        }
    }, [context.currentIdentity, navigate, target]);
}
